import { useCallback } from "react";

export const fetchNetSuiteConfig = async (api: any, teamId: number) => {
  if (!teamId) return null;

  try {
    const resp = await api.messaging.get(`NetSuite/Integrations/`);
    return resp.ok ? await resp.json() : null;
  } catch (error) {
    console.error("Error fetching NetSuite config:", error);
    return null;
  }
};

export const fetchFormstackConfig = async (api: any, enableFormstack?: boolean) => {
  if (!enableFormstack) return null;

  try {
    const response = await api.messaging.get(
      `Formstack/Integrations/GetConfig`
    );

    if (!response.ok) {
      console.error("Failed to fetch Formstack config:", response.statusText);
      return null;
    }

    const text = await response.text();
    if (!text) {
      console.warn("Formstack config response is empty");
      return null;
    }

    return JSON.parse(text); // Manually parse JSON to catch errors
  } catch (error) {
    console.error("Error fetching Formstack config:", error);
    return null;
  }
};

export const fetchAccelaConfig = async (api: any, enableAccela?: boolean) => {
  if (!enableAccela) return null;

  try {
    const resp = await api.messaging.get("Accela/Integrations/");
    return resp.ok ? await resp.json() : null;
  } catch (error) {
    console.error("Error fetching Accela config:", error);
    return null;
  }
};

export const fetchShopifyConfig = async (api: any, enableShopify?: boolean) => {
  if (!enableShopify) return null;

  try {
    const resp = await api.messaging.get("Shopify/Integrations/");
    return resp.ok ? await resp.json() : null;
  } catch (error) {
    console.error("Error fetching Shopify config:", error);
    return null;
  }
};

export const fetchHubSpotConfig = async (api: any, enableHubSpot?: boolean) => {
  if (!enableHubSpot) return null;

  try {
    const resp = await api.admin.get("HubSpot/Configs");
    if (!resp.ok) return null;
    const data = await resp.json();
    return Array.isArray(data) && data.length > 0 ? data : null;
  } catch {
    return null;
  }
};

export const fetchDynamicsConfig = async (api: any, enableDynamics?: boolean) => {
  if (!enableDynamics) return null;

  try {
    const resp = await api.admin.get("Dynamics/Configs");
    if (!resp.ok) return null;
    const data = await resp.json();
    return Array.isArray(data) && data.length > 0 ? data : null;
  } catch {
    return null;
  }
};

export const fetchBigCommerceConfig = async (api: any, enableBigCommerce?: boolean) => {
  if (!enableBigCommerce) return null;

  try {
    const resp = await api.admin.get("BigCommerce/Configs");
    if (!resp.ok) return null;
    const data = await resp.json();
    return Array.isArray(data) && data.length > 0 ? data : null;
  } catch {
    return null;
  }
};

// WooCommerce: no DB table yet — always returns null until the data connector ships
export const fetchWooCommerceConfig = async (_api: any): Promise<null> => {
  return null;
};

export const fetchMagentoConfig = async (api: any, enableMagento?: boolean) => {
  if (!enableMagento) return null;

  try {
    const resp = await api.admin.get("Magento/Configs");
    if (!resp.ok) return null;
    const data = await resp.json();
    return Array.isArray(data) && data.length > 0 ? data : null;
  } catch {
    return null;
  }
};

export const fetchSalesforceConfig = async (api: any) => {
  try {
    const resp = await api.admin.get("Salesforce/Config");
    if (!resp.ok) return null;
    const data = await resp.json();
    return Array.isArray(data) && data.length > 0 ? data : null;
  } catch {
    return null;
  }
};

export const fetchServiceNowConfig = async (api: any) => {
  try {
    const resp = await api.admin.get("ServiceNow/Configs");
    if (!resp.ok) return null;
    const data = await resp.json();
    return Array.isArray(data) && data.length > 0 ? data : null;
  } catch {
    return null;
  }
};